import { headerBackgroundClassFor, headerStyleFor } from '@/lib/display-tweaks';
import { cn } from '@/lib/utils';
import { PALIER_NUMBERS } from '@mss_creator/shared';
import { FAKE_COMPANY } from './fake-company';
import { PreviewFrame } from './preview-frame';
import type { SettingPreviewProps } from './setting-preview-props';
import { SkeletonBar } from './skeleton-bar';

const BODY_ROWS = [0, 1, 2] as const;

/** `matrix-header-theme`: the eight palier headers of a grid, painted by the real theme mappings. */
export function HeaderThemePreview({ value }: SettingPreviewProps) {
  return (
    <PreviewFrame>
      <table className="w-full table-fixed border-collapse">
        <thead>
          <tr>
            {PALIER_NUMBERS.map((palier) => (
              <th
                key={palier}
                style={headerStyleFor(value, FAKE_COMPANY.noyau, palier)}
                className={cn(
                  'border-gray-200 border-r border-b px-2 py-3 text-left font-normal',
                  headerBackgroundClassFor(value, palier),
                )}
              >
                <span className="block h-2 w-3/4 rounded-full bg-current opacity-60" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {BODY_ROWS.map((row) => (
            <tr key={row}>
              {PALIER_NUMBERS.map((palier) => (
                <td
                  key={palier}
                  className="space-y-1 border-gray-100 border-r border-b p-2 align-top"
                >
                  <SkeletonBar width={row % 2 === 0 ? 85 : 70} />
                  <SkeletonBar width={55} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </PreviewFrame>
  );
}
